jQuery(document).on('nfFormReady', function (e, layoutView) {
    function validateField(input, fieldModel) {
        const fieldValue = input.val();
        const fieldType = fieldModel.get('type');

        if (fieldModel.get('required') && !fieldValue) {
            Backbone.Radio.channel('fields').request('add:error', fieldModel.get('id'), 'required-error', 'Dies ist ein Pflichtfeld!');
            return;
        } else {
            Backbone.Radio.channel('fields').request('remove:error', fieldModel.get('id'), 'required-error');
        }

        Backbone.Radio.channel('fields').request('remove:error', fieldModel.get('id'), 'field-error');
        input.addClass('nf-pass');
        input.parents('.field-wrap').addClass('nf-pass');
    }

    const UniversalFieldValidator = Marionette.Object.extend({
        initialize: function () {
            this.listenTo(nfRadio.channel('fields'), 'change:field', this.validateAllFields);
        },

        validateAllFields: function (input, fieldModel) {
            validateField(input, fieldModel);
        }
    });

    new UniversalFieldValidator();
});
